// import { Link, useNavigate } from "react-router-dom";
// import { useLazyLogoutQuery } from "../../redux/api/authApi";
// import { useEffect, useRef, useState } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import { useGetMeQuery } from "../../redux/api/userApi";

// const UserMenu = ({ user, menuOpen, setMenuOpen }) => {
//   const navigate = useNavigate();
//   const [logout, { isSuccess }] = useLazyLogoutQuery();
//   const dropdownRef = useRef(null);
//   const [openDropdown, setOpenDropdown] = useState(false);

//   const { isLoading } = useGetMeQuery();

//   // Refresh after logout
//   useEffect(() => {
//     if (isSuccess) navigate(0);
//   }, [isSuccess, navigate]);

//   // Close dropdown if clicked outside (desktop only)
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setOpenDropdown(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   const logoutHandler = () => logout();

//   // --- Desktop dropdown ---
//   const desktopMenu = (
//     <AnimatePresence>
//       {openDropdown && user && (
//         <motion.div
//           initial={{ opacity: 0, y: -10 }}
//           animate={{ opacity: 1, y: 0 }}
//           exit={{ opacity: 0, y: -10 }}
//           transition={{ duration: 0.2 }}
//           className="absolute right-0 mt-2 w-40 bg-white rounded-lg shadow-xl z-50 overflow-hidden"
//         >
//           <ul className="text-sm font-sourcesans text-stone-700">
//             <li>
//               <Link
//                 to="/me/profile"
//                 className="block px-4 py-2 hover:bg-amber-50 hover:text-amber-700"
//                 onClick={() => setOpenDropdown(false)}
//               >
//                 Profile
//               </Link>
//             </li>
//             <li>
//               <button
//                 onClick={() => {
//                   logoutHandler();
//                   setOpenDropdown(false);
//                 }}
//                 className="w-full text-left px-4 py-2 hover:bg-amber-50 hover:text-amber-700"
//               >
//                 Sign Out
//               </button>
//             </li>
//           </ul>
//         </motion.div>
//       )}
//     </AnimatePresence>
//   );

//   // --- Mobile row inside expanded menu ---
//   const mobileMenu = (
//     user && (
//       <motion.div
//         initial={{ opacity: 0, x: -20 }}
//         animate={{ opacity: 1, x: 0 }}
//         exit={{ opacity: 0, x: -20 }}
//         transition={{ duration: 0.25 }}
//         className="flex items-center justify-between bg-white border border-stone-200 px-4 py-3 rounded-lg mt-4 shadow-sm"
//       >
//         <Link
//           to="/me/profile"
//           onClick={() => setMenuOpen(false)}
//           className="flex-1 text-stone-700 hover:text-amber-700 font-sourcesans font-medium"
//         >
//           Profile
//         </Link>
//         <button
//           onClick={() => {
//             logoutHandler();
//             setMenuOpen(false);
//           }}
//           className="flex-1 text-stone-700 hover:text-amber-700 font-sourcesans font-medium"
//         >
//           Sign Out
//         </button>
//       </motion.div>
//     )
//   );

//   return (
//     <div className="relative" ref={dropdownRef}>
//       {/* Not logged in */}
//       {!user && !isLoading ? (
//         <Link
//           to="/login"
//           className="text-stone-700 hover:text-amber-700 flex items-center"
//           onClick={() => setMenuOpen(false)}
//         >
//           <img
//             src="/images/user.png"
//             alt="Login"
//             className="w-6 h-6 rounded-full"
//           />
//         </Link>
//       ) : (
//         <>
//           {/* Greeting on desktop */}
//           <button
//             onClick={() => setOpenDropdown((prev) => !prev)}
//             className="hidden md:flex items-center space-x-2 cursor-pointer text-stone-700 hover:text-amber-700 font-sourcesans"
//           >
//             <span className="w-8 h-8 rounded-full bg-amber-100 flex items-center justify-center text-amber-700 font-semibold">
//               {user?.name?.[0]?.toUpperCase()}
//             </span>
//             <span className="text-sm">Hello, {user?.name?.split(" ")[0]}</span>
//           </button>

//           {/* Dropdown on desktop */}
//           {desktopMenu}

//           {/* On mobile: greeting row */}
//           <div className="md:hidden mt-2">
//             <p className="text-stone-700 font-sourcesans text-base mb-2">
//               Hello, <span className="font-medium">{user?.name}</span>
//             </p>
//             {mobileMenu}
//           </div>
//         </>
//       )}
//     </div>
//   );
// };

// export default UserMenu;

import { Link, useLocation, useNavigate } from "react-router-dom";
import { useLazyLogoutQuery, useLogoutMutation } from "../../redux/api/authApi";
import { useEffect, useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useGetMeQuery } from "../../redux/api/userApi";
import { User2Icon } from "lucide-react";

const UserMenu = ({ user, menuOpen, setMenuOpen }) => {
  const navigate = useNavigate();
  const [logout, { isSuccess }] = useLazyLogoutQuery();
  const dropdownRef = useRef(null);
  const [openDropdown, setOpenDropdown] = useState(false);

  const { isLoading } = useGetMeQuery();
  const location = useLocation();
  const isHome = location.pathname === "/";
  // Refresh after logout
  useEffect(() => {
    if (isSuccess) navigate(0);
  }, [isSuccess, navigate]);

  // Close dropdown if clicked outside (desktop only)
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const logoutHandler = () => logout();

  // --- Desktop dropdown ---
  const desktopMenu = (
    <AnimatePresence>
      {openDropdown && user && (
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.2 }}
          className="absolute right-0 mt-2 w-44 bg-[#ffffff] rounded-lg shadow-lg z-50 overflow-hidden border border-[#8a4b32]/20"
        >
          <ul className="text-sm font-sourcesans text-[#1c1917]">
            <li>
              <Link
                to="/me/profile"
                className="block px-4 py-2 hover:bg-[#f5f3ea] hover:text-[#BC3F4A] transition"
                onClick={() => setOpenDropdown(false)}
              >
                Profile
              </Link>
            </li>
            {user?.role === "admin" && (
              <li>
                <Link
                  to="/admin/dashboard"
                  className="block px-4 py-2 hover:bg-[#f5f3ea] hover:text-[#BC3F4A] transition"
                  onClick={() => setOpenDropdown(false)}
                >
                  Dashboard
                </Link>
              </li>
            )}
            <li>
              <button
                onClick={() => {
                  logoutHandler();
                  setOpenDropdown(false);
                }}
                className="w-full text-left px-4 py-2 hover:bg-[#f5f3ea] hover:text-[#BC3F4A] transition"
              >
                Sign Out
              </button>
            </li>
          </ul>
        </motion.div>
      )}
    </AnimatePresence>
  );

  // --- Mobile row inside expanded menu ---
  const mobileMenu = user && (
    <motion.div
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -20 }}
      transition={{ duration: 0.25 }}
      className="flex items-center justify-between bg-[#ffffff] border border-[#8a4b32]/30 px-4 py-3 rounded-lg mt-4 shadow-sm"
    >
      <Link
        to="/me/profile"
        onClick={() => setMenuOpen(false)}
        className="flex-1 text-[#1c1917] hover:text-[#BC3F4A] font-sourcesans font-medium transition"
      >
        Profile
      </Link>

      {user?.role === "admin" && (
        <Link
          to="/admin/dashboard"
          onClick={() => setMenuOpen(false)}
          className="flex-1 text-[#1c1917] hover:text-[#BC3F4A] font-sourcesans font-medium transition"
        >
          Dashboard
        </Link>
      )}

      <button
        onClick={() => {
          logoutHandler();
          setMenuOpen(false);
        }}
        className="flex-1 text-[#1c1917] hover:text-[#BC3F4A] font-sourcesans font-medium transition"
      >
        Sign Out
      </button>
    </motion.div>
  );

  return (
    <div className="relative" ref={dropdownRef}>
      {/* Not logged in */}
      {!user && !isLoading ? (
        <>
        {/* Desktop: user icon */}
        <Link
          to="/login"
          className="hidden md:flex items-center text-stone-700 hover:text-[#BC3F4A] transition"
          onClick={() => setMenuOpen(false)}
        >
         <User2Icon strokeWidth="2" className={`${isHome ? "text-white" : "text-stone-700"} w-6 h-6`} />
        </Link>
    
        {/* Mobile: Login/Register buttons */}
        <div className="flex flex-col space-y-2 mt-2 md:hidden">
          <Link
            to="/login"
            onClick={() => setMenuOpen(false)}
            className="flex items-center justify-center py-2 text-[#1c1917] hover:text-[#BC3F4A] font-sourcesans font-medium transition border border-[#8a4b32]/30 rounded-lg"
          >
            Sign In
          </Link>
          <Link
            to="/register"
            onClick={() => setMenuOpen(false)}
            className="flex items-center justify-center py-2 text-[#1c1917] hover:text-[#BC3F4A] font-sourcesans font-medium transition border border-[#8a4b32]/30 rounded-lg"
          >
            Sign Up
          </Link>
        </div>
      </>
      ) : (
        <>
          {/* Greeting on desktop */}
          <button
            onClick={() => setOpenDropdown((prev) => !prev)}
            className={`hidden md:flex items-center space-x-2 cursor-pointer ${isHome ? "text-[#f5f3ea]" : "text-[#1c1917]"}   font-sourcesans font-medium rounded-md px-2 py-1 transition`}
          >
            <span className={`w-8 h-8 rounded-full border border-[#f3efe0] flex items-center justify-center ${isHome ? "text-[#f5f3ea]" : "text-[#1c1917]"}  font-semibold`}>
              {user?.name?.[0]?.toUpperCase()}
            </span>
            <span className="text-sm">Hello, {user?.name?.split(" ")[0]}</span>
            <svg
              className={`w-4 h-4 ml-1 transition-transform duration-200 ${
                openDropdown ? "rotate-180" : ""
              }`}
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </button>

          {/* Dropdown on desktop */}
          {desktopMenu}

          {/* On mobile: greeting row */}
          <div className="md:hidden mt-2">
            <p className="text-[#1c1917] font-sourcesans text-base mb-2 ">
              Hello, <span className="font-medium ">{user?.name}</span>
            </p>
            {mobileMenu}
          </div>
        </>
      )}
    </div>
  );
};

export default UserMenu;
